import Vue from 'vue'
//加载文件
import App from './App'
//加载文件夹
import router from './router'
//引入公共配置文件
import config from '../config/index.js'
Vue.prototype.config = config;
// 引入iview
import ViewUI from 'view-design';
// import style
import 'view-design/dist/styles/iview.css';
Vue.use(ViewUI);

// 引入对css less的支持
import '!style-loader!css-loader!less-loader!./theme/index.less'
//引入交互
import axios from './axios/axios'
//为axios起一个别名
Vue.prototype.$http = axios;
//引入vuex
import store from './store';

import PortalVue from 'portal-vue'
Vue.use(PortalVue)

//全局提示插件
import MessageUtils from '@/utils/MessageUtils.js'
Vue.use(MessageUtils)
import NoticeUtils from '@/utils/NoticeUtils.js'
Vue.use(NoticeUtils)
//导出IMAGE
import ExportImage from '@/utils/ExportImage.js'
Vue.use(ExportImage)
//导出PDF
import ExportPDF from '@/utils/ExportPDF.js'
Vue.use(ExportPDF)
//引入vue-bus
import vueBus from './utils/vue-bus.js'
Vue.use(vueBus)

//解决在ie11中打开空页面的问题
import 'babel-polyfill'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer);

Viewer.setDefaults({
  Options: { "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});

import VueTour from 'vue-tour'
require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)

//公共js处理方法
import ChartsUtils from '@/utils/ChartsUtils.js'
Vue.prototype.ChartsUtils = ChartsUtils;

/* eslint-disable no-new */
/*
 template:一个字符串模板作为 Vue 实例的标识使用。
模板将会 替换 挂载的元素。挂载元素的内容都将被忽略，除非模板的内容有分发插槽。
components:包含 Vue 实例可用组件的哈希表
 */
var vm  = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
});

const AUTH_WHITE_LIST = ['/', '/login', '/forgetPassword']

// 拦截通过地址栏直接访问的路由
router.beforeResolve((to, from, next) => {
  if (AUTH_WHITE_LIST.indexOf(to.path) > -1) {
    next()
  } else {
    validatorUserInfo(to, from, next)
  }
})

//全局守卫
router.beforeEach((to,from,next) =>{
  if (AUTH_WHITE_LIST.indexOf(to.path) > -1) {
    next()
  } else {
    validatorUserInfo(to, from, next)
  }
})

function validatorUserInfo(to, from, next){
  if(!sessionStorage.userInfo || sessionStorage.userInfo === 'undefined'){
    vm.$http({
      method:'post',
      url:vm.config.serverUrl+'/classbrand/base/getUsers',
      data:{}
    }).then(function (response) {
      if(response.data.code=="1"){
        var userInfo = response.data.userInfo;
        if(null == userInfo){
          next("/login");
        }else{
          sessionStorage.userInfo = JSON.stringify(userInfo);
          next();
        }
      }else{
        next("/login");
      }
    }).catch(function (response) {
      next("/login");
      console.log(response);
    });
  }else{
    next();
  }
}

Vue.prototype.$imgSrc = (name) => {
  var image = {id:'',name:'',url:''};
  if (process.env.NODE_ENV === 'development') { // 开发环境
    image.id = name.substring(name.indexOf("_")+1,name.indexOf("."));
    image.name = name;
    image.url = require('./assets/template/' + name)
  } else { // 生产环境
    image.id = name.substring(name.indexOf("_")+1,name.indexOf("."));
    image.name = name;
    image.url = require('./assets/template/' + name)
  }
  return image
};

Vue.filter('formatSize', function (size) {
  if (size > 1024 * 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB'
  } else if (size > 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB'
  } else if (size > 1024 * 1024) {
    return (size / 1024 / 1024).toFixed(2) + ' MB'
  } else if (size > 1024) {
    return (size / 1024).toFixed(2) + ' KB'
  }
  return size.toString() + ' B'
})



// WEBPACK FOOTER //
// ./src/main.js